import React, { useState } from 'react';
import InputMask from "react-input-mask";
import { toast } from 'react-toastify';
import Api from '../services/Api';

const ListItemVehicle = ({ item, onDelete, loadItem, setLoading }) => {
    const [toggleItem, setToggleItem] = useState([]);
    const [statePlaca, setStatePlaca] = useState(item.placa || '');
    const [stateTara, setStateTara] = useState(item.tara || 0);
    const [stateCapacidadeKG, setStateCapacidadeKG] = useState(item.capacidadeKG || 0);
    const [stateCapacidadeM3, setStateCapacidadeM3] = useState(item.capacidadeM3 || 0);
    const [stateTipoRodado, setStateTipoRodado] = useState(item.tipoRodado || '03');
    const [stateTipoCarroceria, setStateTipoCarroceria] = useState(item.tipoCarroceria || '00');
    const [stateRENAVAM, setStateRENAVAM] = useState(item.RENAVAM || '');
    const [stateUF_veiculo, setStateUF_veiculo] = useState(item.UF_veiculo || 'RS');
    const [stateProprietario, setStateProprietario] = useState(item.Proprietario || {
        CPF_prop: "",
        CNPJ_prop: "",
        RNTRC_prop: "",
        nome_prop: "",
        IE_prop: "",
        UF_prop: "RS",
        tipo_prop: 0
    });
    const [stateCondutor, setStateCondutor] = useState(item.Condutor || {
        nome_cond: "",
        CPF_cond: ""
    });
    const [stateActive, setStateActive] = useState(item.active !== false);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const data = {
            placa: statePlaca.toUpperCase(),
            tara: stateTara,
            capacidadeKG: stateCapacidadeKG,
            capacidadeM3: stateCapacidadeM3,
            tipoRodado: stateTipoRodado,
            tipoCarroceria: stateTipoCarroceria,
            RENAVAM: stateRENAVAM,
            UF_veiculo: stateUF_veiculo,
            Proprietario: stateProprietario,
            Condutor: stateCondutor,
            active: stateActive
        };
        if (item._id && String(item._id).match(/^[0-9a-fA-F]{24}$/)) {
            data._id = item._id;
        }

        try {
            const response = await Api.saveItem("store-vehicle", data);
            if (response && response.success) {
                toast.success(response.message || "Operação realizada com sucesso!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                setToggleItem([]);
                loadItem();
            } else {
                toast.error(response?.message || "Falha ao salvar", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    function handleProprietarioChange(field, value) {
        setStateProprietario({ ...stateProprietario, [field]: value });
    }

    function handleCondutorChange(field, value) {
        setStateCondutor({ ...stateCondutor, [field]: value });
    }

    async function updateStatus(status) {
        if (item._id && String(item._id).match(/^[0-9a-fA-F]{24}$/)) {
            try {
                setLoading(true);
                const data = {
                    _id: item._id,
                    placa: statePlaca.toUpperCase(),
                    tara: stateTara,
                    capacidadeKG: stateCapacidadeKG,
                    capacidadeM3: stateCapacidadeM3,
                    tipoRodado: stateTipoRodado,
                    tipoCarroceria: stateTipoCarroceria,
                    RENAVAM: stateRENAVAM,
                    UF_veiculo: stateUF_veiculo,
                    Proprietario: stateProprietario,
                    Condutor: stateCondutor,
                    active: status
                };
                const response = await Api.saveItem("store-vehicle", data);
                if (response && response.success) {
                    toast.success("Status atualizado com sucesso!", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    loadItem();
                } else {
                    toast.error(response?.message || "Falha ao atualizar status", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    setStateActive(!status);
                }
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
                setStateActive(!status);
            }
        }
    }

    return (
        <li className={toggleItem[0] === item._id ? "itemDashboardList itemDashboardListActive" : "itemDashboardList"} style={stateActive ? {} : { opacity: 0.4 }}>
            <div className="row headList" onClick={() => { toggleItem[0] !== item._id ? setToggleItem([item._id]) : setToggleItem([]) }}>
                <div className="col-8">
                    <span>{statePlaca.toUpperCase() || "NOVO VEÍCULO"} - {stateTipoCarroceria}/{stateTipoRodado}</span>
                </div>
                <div className="col-4 text-right">
                    <span className={`iconItem ${toggleItem[0] === item._id ? 'fas fa-angle-up fa-lg ' : 'fas fa-angle-down fa-lg '}`}></span>
                </div>
            </div>
            {toggleItem[0] === item._id ?
                <div className="row">
                    <div className="col-12">
                        <hr />
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <label className="switch itemDashboardListSwitch" style={{ marginTop: -28 }}>
                                    <input type="checkbox" value={stateActive} checked={stateActive} onChange={(e) => {
                                        setStateActive(e.target.checked);
                                        updateStatus(e.target.checked);
                                    }} />
                                    <div className="slider"></div>
                                </label>
                                <div className="form-group col-md-4">
                                    <label className="labelInput">Placa:</label>
                                    <input type="text" className="form-control" style={{ textTransform: 'uppercase' }} value={statePlaca} onChange={e => setStatePlaca(e.target.value.toUpperCase())} required />
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="labelInput">Tara (kg):</label>
                                    <input type="number" className="form-control" value={stateTara} onChange={e => setStateTara(e.target.value)} required />
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="labelInput">RENAVAM:</label>
                                    <input type="text" className="form-control" value={stateRENAVAM} onChange={e => setStateRENAVAM(e.target.value)} required />
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="labelInput">Capacidade KG:</label>
                                    <input type="number" className="form-control" value={stateCapacidadeKG} onChange={e => setStateCapacidadeKG(e.target.value)} required />
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="labelInput">Capacidade M3:</label>
                                    <input type="number" className="form-control" value={stateCapacidadeM3} onChange={e => setStateCapacidadeM3(e.target.value)} required />
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="labelInput">Tipo Rodado:</label>
                                    <input type="text" className="form-control" value={stateTipoRodado} onChange={e => setStateTipoRodado(e.target.value)} placeholder="03" required />
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="labelInput">Tipo Carroceria:</label>
                                    <input type="text" className="form-control" value={stateTipoCarroceria} onChange={e => setStateTipoCarroceria(e.target.value)} placeholder="00" required />
                                </div>

                                <div className="form-group col-md-12">
                                    <h5 style={{ marginTop: 15 }}>Proprietário</h5>
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="labelInput">Nome Proprietário:</label>
                                    <input type="text" className="form-control" value={stateProprietario.nome_prop || ""} onChange={e => handleProprietarioChange("nome_prop", e.target.value)} />
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="labelInput">CNPJ Proprietário:</label>
                                    <InputMask mask="99.999.999/9999-99" maskChar={null} className="form-control" value={stateProprietario.CNPJ_prop || ""} onChange={e => handleProprietarioChange("CNPJ_prop", e.target.value)} />
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="labelInput">CPF Proprietário:</label>
                                    <InputMask mask="999.999.999-99" maskChar={null} className="form-control" value={stateProprietario.CPF_prop || ""} onChange={e => handleProprietarioChange("CPF_prop", e.target.value)} />
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="labelInput">RNTRC Proprietário:</label>
                                    <input type="text" className="form-control" value={stateProprietario.RNTRC_prop || ""} onChange={e => handleProprietarioChange("RNTRC_prop", e.target.value)} />
                                </div>

                                <div className="form-group col-md-12">
                                    <h5 style={{ marginTop: 15 }}>Motorista Padrão</h5>
                                </div>
                                <div className="form-group col-md-6">
                                    <label className="labelInput">Nome Motorista:</label>
                                    <input type="text" className="form-control" value={stateCondutor.nome_cond || ""} onChange={e => handleCondutorChange("nome_cond", e.target.value)} />
                                </div>
                                <div className="form-group col-md-6">
                                    <label className="labelInput">CPF Motorista:</label>
                                    <InputMask mask="999.999.999-99" maskChar={null} className="form-control" value={stateCondutor.CPF_cond || ""} onChange={e => handleCondutorChange("CPF_cond", e.target.value)} />
                                </div>
                            </div>
                            <div className="col-12 text-right">
                                <hr />
                                <button type="button" className="btn btn-delete" onClick={onDelete}> Excluir </button>
                                <span>&nbsp;&nbsp;&nbsp;</span>
                                <button type="submit" className="btn btn-default"> Salvar </button>
                            </div>
                        </form>
                    </div>
                </div>
                : ''}
        </li>
    );
};

export default ListItemVehicle;
